module.exports = __webpack_public_path__ + "img/package_feedbin.e3de0367.svg";